import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const CandidateIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <g>
                    <g>
                        <g>
                            <path
                                fill="currentColor"
                                d="M17.7,19.9H2.9v-1.9c0-1.2,0.7-2.2,1.8-2.6l3.2-1.1v-1.4h1.2v2.3l-4,1.4c-0.6,0.2-1,0.8-1,1.5v0.7h12.4
					v-0.7c0-0.7-0.4-1.2-1-1.5l-4-1.4v-2.3h1.2v1.4l3.2,1.1c1.1,0.4,1.8,1.4,1.8,2.6V19.9z"
                            />
                        </g>
                        <g>
                            <path
                                fill="currentColor"
                                d="M10.3,14C8,14,6.1,11.8,6.1,9.1c0-2.7,1.9-4.9,4.2-4.9s4.2,2.2,4.2,4.9C14.5,11.8,12.6,14,10.3,14z
                                M10.3,5.4c-1.6,0-3,1.7-3,3.7c0,2,1.3,3.7,3,3.7c1.6,0,3-1.7,3-3.7C13.3,7,11.9,5.4,10.3,5.4z"
                            />
                        </g>
                    </g>
                </g>
                <g>
                    <polygon
                        fill="currentColor"
                        points="21.1,5 18.1,8 16.1,6 16.9,5.1 18.1,6.3 20.3,4.1 		"
                    />
                </g>
            </g>
        </SvgIcon>
    );
};
